export default __webpack_public_path__ + "images/union-area-stone.svg";